module.exports = __webpack_public_path__ + "static/media/face-to-face-bro-people.cecbacef.svg";